class TextFit extends HTMLElement {
  maxAttempts = 10

  constructor() {
    super()

    const shadowRoot = this.attachShadow({ mode: "open" })
    shadowRoot.innerHTML = `
      <style>#text-fit { display: flex; flex-wrap: wrap; }</style>
      <div id="text-fit"><slot /></div>
    `

    // TODO: allow for these to be changed
    if (this.hasAttribute("min")) {
      this.min = parseInt(this.getAttribute("min"))
    }
    this.min = 10
    if (this.hasAttribute("max")) {
      this.max = parseInt(this.getAttribute("max"))
    }
    this.max = 1000
  }

  connectedCallback() {
    this.fit()

    this.resizeObserver = new ResizeObserver((_) => {
      this._clearBoundingClientRects()
      this.fit()
    })
    this.resizeObserver.observe(this)
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect()
  }

  fit() {
    if (!this.hasContent) return
    let low = this.min
    let high = this.max
    let size = low

    // Binary search for highest best fit
    // (https://github.com/STRML/textFit/blob/master/textFit.js#L154)
    while (low <= high) {
      let mid = (high + low) >> 1
      this.fontSize = mid
      if (this.isContained) {
        size = mid
        low = mid + 1
      } else {
        high = mid - 1
      }
    }

    // Stupid hack ...
    // With the binary search returning "highest best fit", it is often slightly
    // too large, so deduct 1px until we fit.
    let i = 0
    do {
      size = size - 1
      this.fontSize = size
      i++
    } while (
      !this.isContained &&
      i < this.maxAttempts &&
      size > this.min &&
      size < this.max
    )

    if (this.fontSize != size) this.fontSize = size
  }

  _clearBoundingClientRects() {
    this._boundingClientRect = null
  }

  get content() {
    return this.firstElementChild
  }

  get hasContent() {
    return this.content !== null
  }

  get fontSize() {
    return this._fontSize
  }

  set fontSize(value) {
    if (this.fontSize == value) return
    this._fontSize = value
    this.style.fontSize = `${value}px`
  }

  get isContained() {
    const contentBoundingRect = this.content.getBoundingClientRect()
    return (
      contentBoundingRect.width <= this.maxWidth &&
      contentBoundingRect.height <= this.maxHeight
    )
  }

  get maxHeight() {
    return this.boundingClientRect.height
  }

  get maxWidth() {
    return this.boundingClientRect.width
  }

  get boundingClientRect() {
    if (!this._boundingClientRect) {
      this._boundingClientRect = this.getBoundingClientRect()
    }
    return this._boundingClientRect
  }
}

customElements.define("text-fit", TextFit)
